import React from "react";
import { ShoppingBasket, Grid, GalleryHorizontal, ExternalLink } from 'lucide-react';

const FilterBar = ({ categories, selectedCategory, onCategorySelect, viewMode, toggleViewMode, isDesktop, showViewToggle = true }) => {
    const effectiveSelectedCategory = selectedCategory || categories[0]?.id;

    return (
        <div className={`font-matter font-thin text-s px-4 md:px-12 py-2 mt-2 md:mt-10 ${isDesktop ? 'w-auto' : 'w-full'}`}>
            <div className={`flex ${isDesktop ? 'flex-row items-center justify-between' : 'flex-col'}`}>
                <div className={`flex ${isDesktop ? 'flex-row space-x-4' : 'flex-col space-y-2'}`}>
                    {categories.map((category) => {
                        const baseClassName = `
                                cursor-pointer
                                text-black
                                hover:text-primary
                                transition-colors
                                relative
                                py-2 md:py-0
                                after:absolute
                                after:bottom-0
                                after:left-0
                                after:w-full
                                after:h-0.5
                                after:bg-primary
                                after:transition-all
                                after:duration-300
                                ${effectiveSelectedCategory === category.id
                                ? 'after:scale-x-100'
                                : 'after:scale-x-0 hover:after:scale-x-100'
                            }
                            `;

                        const content = category.id === 'shop' ? (
                            <span className="flex items-center">
                                {category.name}
                                <ShoppingBasket className="ml-1" size={16} />
                            </span>
                        ) : category.externalUrl ? (
                            <span className="flex items-center">
                                {category.name}
                                <ExternalLink className="ml-1" size={16} />
                            </span>
                        ) : (
                            category.name
                        );

                        if (category.externalUrl) {
                            return (
                                <a
                                    key={category.id}
                                    href={category.externalUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={baseClassName}
                                >
                                    {content}
                                </a>
                            );
                        }

                        return (
                            <span
                                key={category.id}
                                className={baseClassName}
                                onClick={() => onCategorySelect(category.id)}
                            >
                                {content}
                            </span>
                        );
                    })}
                </div>
                {isDesktop && showViewToggle && (
                    <button
                        onClick={toggleViewMode}
                        className="p-2 rounded-full hover:bg-gray-200 transition-colors duration-200"
                    >
                        {viewMode === 'carousel' ? <Grid size={20} /> : <GalleryHorizontal size={20} />}
                    </button>
                )}
            </div>
        </div>
    );
};

export default FilterBar;
